module.exports = __webpack_public_path__ + "static/media/about-vision.0a94fdc4.jpg";